package flagpack.icons.medium

import androidx.compose.foundation.Image
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.padding
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.PathData
import androidx.compose.ui.graphics.vector.group
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import flagpack.icons.FlagIcons
import org.jetbrains.compose.ui.tooling.preview.Preview

/**
 * Lesotho Flag (20x15dp)
 *
 * - ISO Alpha-2: LS
 * - ISO Alpha-3: LSO
 * - ISO Numeric: 426
 *
 * @see [Flagpack](https://flagpack.xyz)
 */
public val FlagIcons.Medium.Lesotho: ImageVector by lazy {
    ImageVector.Builder(
        name = "Lesotho:LS:LSO:426:Medium",
        defaultWidth = 20.dp,
        defaultHeight = 15.dp,
        viewportWidth = 20f,
        viewportHeight = 15f
    ).apply {
        group(
            clipPathData = PathData {
                moveTo(0f, 0f)
                horizontalLineToRelative(20f)
                verticalLineToRelative(15f)
                horizontalLineToRelative(-20f)
                close()
            }
        ) {
            path(fill = SolidColor(Color.White)) {
                moveTo(0f, 0f)
                horizontalLineToRelative(20f)
                verticalLineToRelative(15f)
                horizontalLineToRelative(-20f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFF55BA07)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(0f, 10f)
                horizontalLineTo(20f)
                verticalLineTo(15f)
                horizontalLineTo(0f)
                verticalLineTo(10f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFF7FCFF)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(0f, 5f)
                horizontalLineTo(20f)
                verticalLineTo(10f)
                horizontalLineTo(0f)
                verticalLineTo(5f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFF3D58DB)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(0f, 0f)
                horizontalLineTo(20f)
                verticalLineTo(5f)
                horizontalLineTo(0f)
                verticalLineTo(0f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFF1D1D1D)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(9.531f, 5.15f)
                curveTo(9.205f, 5.238f, 9.032f, 5.464f, 9.032f, 5.863f)
                curveTo(9.032f, 6.32f, 9.256f, 6.748f, 9.531f, 6.969f)
                verticalLineTo(5.15f)
                close()
                moveTo(10.313f, 6.957f)
                curveTo(10.58f, 6.733f, 10.795f, 6.312f, 10.795f, 5.864f)
                curveTo(10.795f, 5.476f, 10.625f, 5.252f, 10.313f, 5.158f)
                verticalLineTo(6.957f)
                close()
                moveTo(10.286f, 4.833f)
                curveTo(10.798f, 4.946f, 11.168f, 5.295f, 11.168f, 5.861f)
                curveTo(11.168f, 6.272f, 10.972f, 6.773f, 10.668f, 7.116f)
                lineTo(12.189f, 8.608f)
                lineTo(12.565f, 8.484f)
                lineTo(13.125f, 9.334f)
                curveTo(13.125f, 9.334f, 11.709f, 10f, 9.958f, 10f)
                curveTo(8.208f, 10f, 6.875f, 9.334f, 6.875f, 9.334f)
                lineTo(7.352f, 8.608f)
                lineTo(7.737f, 8.734f)
                lineTo(9.148f, 7.142f)
                curveTo(8.832f, 6.798f, 8.626f, 6.283f, 8.626f, 5.861f)
                curveTo(8.626f, 5.275f, 9.022f, 4.922f, 9.562f, 4.821f)
                curveTo(9.622f, 4.682f, 9.76f, 4.583f, 9.922f, 4.583f)
                curveTo(10.088f, 4.583f, 10.229f, 4.687f, 10.286f, 4.833f)
                close()
                moveTo(7.501f, 8.935f)
                lineTo(7.343f, 9.156f)
                horizontalLineTo(7.651f)
                lineTo(7.501f, 8.935f)
                close()
                moveTo(7.682f, 9.242f)
                lineTo(7.409f, 9.297f)
                lineTo(7.682f, 9.392f)
                verticalLineTo(9.242f)
                close()
                moveTo(7.821f, 8.925f)
                lineTo(7.96f, 9.25f)
                lineTo(8.306f, 9.156f)
                lineTo(8.237f, 9.025f)
                lineTo(7.821f, 8.925f)
                close()
                moveTo(8.573f, 9.574f)
                lineTo(8.065f, 9.474f)
                lineTo(8.007f, 9.376f)
                lineTo(8.39f, 9.292f)
                lineTo(8.573f, 9.574f)
                close()
                moveTo(8.603f, 9.108f)
                lineTo(8.761f, 9.392f)
                lineTo(9.108f, 9.287f)
                lineTo(9.011f, 9.159f)
                lineTo(8.603f, 9.108f)
                close()
                moveTo(8.887f, 9.63f)
                lineTo(8.825f, 9.513f)
                lineTo(9.209f, 9.41f)
                lineTo(9.431f, 9.68f)
                lineTo(8.887f, 9.63f)
                close()
                moveTo(9.605f, 9.435f)
                lineTo(10.1f, 9.304f)
                lineTo(10.039f, 9.192f)
                horizontalLineTo(9.396f)
                lineTo(9.605f, 9.435f)
                close()
                moveTo(9.782f, 9.686f)
                lineTo(9.704f, 9.564f)
                lineTo(10.179f, 9.408f)
                lineTo(10.432f, 9.686f)
                horizontalLineTo(9.782f)
                close()
                moveTo(10.384f, 9.201f)
                lineTo(10.536f, 9.387f)
                lineTo(10.948f, 9.244f)
                lineTo(10.896f, 9.147f)
                lineTo(10.384f, 9.201f)
                close()
                moveTo(11.278f, 9.588f)
                lineTo(10.724f, 9.649f)
                lineTo(10.643f, 9.512f)
                lineTo(11.061f, 9.374f)
                lineTo(11.278f, 9.588f)
                close()
                moveTo(11.243f, 9.111f)
                lineTo(11.398f, 9.301f)
                lineTo(11.77f, 9.111f)
                lineTo(11.666f, 9.053f)
                lineTo(11.243f, 9.111f)
                close()
                moveTo(11.564f, 9.537f)
                lineTo(11.497f, 9.434f)
                lineTo(11.851f, 9.221f)
                lineTo(12.031f, 9.434f)
                lineTo(11.564f, 9.537f)
                close()
                moveTo(11.915f, 8.944f)
                lineTo(12.14f, 9.158f)
                lineTo(12.359f, 8.944f)
                lineTo(12.29f, 8.856f)
                lineTo(11.915f, 8.944f)
                close()
                moveTo(12.272f, 9.231f)
                lineTo(12.455f, 9.05f)
                lineTo(12.586f, 9.231f)
                lineTo(12.272f, 9.333f)
                verticalLineTo(9.231f)
                close()
            }
        }
    }.build()
}

@Preview
@Composable
private fun LesothoPreview() {
    Box(modifier = Modifier.padding(12.dp)) {
        Image(
            imageVector = FlagIcons.Medium.Lesotho,
            contentDescription = "Lesotho Flag"
        )
    }
}
